import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import {
  FaUser,
  FaTrophy,
  FaHistory,
  FaGift,
  FaBell,
  FaLifeRing,
  FaGavel,
  FaSignOutAlt,
  FaHome,
} from 'react-icons/fa';
import { AiOutlineClose } from 'react-icons/ai';
import { IoMdNotifications } from 'react-icons/io';
import { toast } from 'react-toastify';
import { userToken } from '../redux/actions';
import { get } from '../service/api';

const SidebarMenu = ({ isOpen, closeSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetail = useSelector(
    (state) => state?.userDetailReducer?.userDetail,
  );

  const [mobileNo, setMobileNo] = useState('');
  const [messageDetails, setMessageDetail] = useState({});

  useEffect(() => {
    getMessageDetails();
  }, []);

  const getMessageDetails = async () => {
    try {
      const response = await get('/messages/getMessageList');
      const data = await response;
      setMessageDetail(data?.response);
      setMobileNo(data?.response?.whatsapp_number);
    } catch (err) {
      console.error('Error fetching messages:', err);
    }
  };

  const openWhatsApp = () => {
    const msg =
      messageDetails[0]?.notice_msg || 'Hi, I am trying to connect with you';
    if (mobileNo) {
      window.open(
        `https://wa.me/91${mobileNo}?text=${encodeURIComponent(msg)}`,
        '_blank',
      );
    } else {
      toast.error('WhatsApp number not found.', { autoClose: 2000 });
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    dispatch(userToken(null));
    toast.success('Logged out successfully!', { autoClose: 2000 });
    navigate('/login');
  };

  return (
    <div
      className={`fixed inset-y-0 left-0 w-64 bg-gray-900 text-white transform ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } transition-transform duration-300 ease-in-out z-50`}
      onClick={closeSidebar}
    >
      {/* Close Button */}
      <div className="flex justify-end p-4">
        <button
          onClick={closeSidebar}
          className="text-white hover:text-red-500 text-2xl"
        >
          <AiOutlineClose />
        </button>
      </div>

      {/* Sidebar Menu */}
      <nav className="flex flex-col space-y-4 px-6">
        <Link
          to="/home"
          className="flex items-center space-x-3 p-2 hover:bg-gray-700 rounded"
        >
          <FaHome className="text-xl" />
          <span>Home</span>
        </Link>
        <Link
          to="/profile"
          className="flex items-center space-x-3 p-2 hover:bg-gray-700 rounded"
        >
          <FaUser className="text-xl" />
          <span>Profile</span>
        </Link>
        <Link
          to="/mywins"
          className="flex items-center space-x-3 p-2 hover:bg-gray-700 rounded"
        >
          <FaTrophy className="text-xl" />
          <span>Winnings</span>
        </Link>
        <Link
          to="/biddings"
          className="flex items-center space-x-3 p-2 hover:bg-gray-700 rounded"
        >
          <FaHistory className="text-xl" />
          <span>Play History</span>
        </Link>
        <Link
          to="/help"
          onClick={openWhatsApp}
          className="flex items-center space-x-3 p-2 hover:bg-gray-700 rounded w-full text-left"
        >
          <FaLifeRing className="text-xl" />
          <span>Help</span>
        </Link>
        <Link
          to="/notifications"
          className="flex items-center space-x-3 p-2 hover:bg-gray-700 rounded"
        >
          <IoMdNotifications className="text-xl" />
          <span>Notifications</span>
        </Link>
        <Link
          to="/commission"
          className="flex items-center space-x-3 p-2 hover:bg-gray-700 rounded"
        >
          <FaGavel className="text-xl" />
          <span>Commission</span>
        </Link>

        <Link
          to="/privacy-policy"
          className="flex items-center space-x-3 p-2 hover:bg-gray-700 rounded"
        >
          <FaGavel className="text-xl" />
          <span>Privacy Policy</span>
        </Link>
        <Link
          to="/terms"
          className="flex items-center space-x-3 p-2 hover:bg-gray-700 rounded"
        >
          <FaGavel className="text-xl" />
          <span>Terms & Conditions</span>
        </Link>
        <button
          onClick={handleLogout}
          className="flex items-center space-x-3 p-2 bg-red-500 hover:bg-red-600 rounded w-full text-left"
        >
          <FaSignOutAlt className="text-xl" />
          <span>Logout</span>
        </button>
      </nav>
    </div>
  );
};

export default SidebarMenu;
